module.exports = __webpack_public_path__ + "img/RepGuideLogoNoText.277d7b10.svg";